import React from 'react'
import { Prompt, Redirect, Route, Switch } from 'react-router-dom'
import Spinner from '../../../ui/Spinner/Spinner'
import Button from '../../../ui/Button/Button'
import ModulePanel from '../../../ui/ModulePanel/ModulePanel'
import { GiftsConfigProvider, useGiftsConfig } from './GiftsConfigContext'
import { GiftsFundProvider } from './GiftsFundContext'
import GiftsSubNav from './GiftsSubNav'
import GiftsRules from './GiftsRules'
import GiftsPackaging from './GiftsPackaging'
import GiftsFund from './GiftsFund'
import styles from './MarketingGifts.module.scss'

const SUB_TAB_LINKS = [
  { title: 'Подарунковий фонд', path: '/marketing/gifts/fund' },
  { title: 'Правила видачі', path: '/marketing/gifts/rules' },
  { title: 'Подарункове пакування', path: '/marketing/gifts/packaging' },
]

function MarketingGiftsBody() {
  const { isLoading, loadStatus, loadError, isDirty, hasDraft, isEditable, reloadConfig } =
    useGiftsConfig()

  return (
    <div className={styles.root}>
      <Prompt when={isDirty} message="Є незбережені зміни. Залишити сторінку без збереження?" />
      <GiftsSubNav links={SUB_TAB_LINKS} />

      <div className={styles.content}>
        {isLoading ? <Spinner type="module" /> : null}

        {loadStatus === 'error' ? (
          <ModulePanel title="Подарунки">
            <p className={styles.stateText}>{loadError}</p>
            <p className={styles.stateHint}>
              Початкові значення не підставлено, щоб випадково не перезаписати наявні налаштування.
            </p>
            <Button title="Повторити завантаження" theme="solid" fill="accent" size={32} onClick={reloadConfig} />
          </ModulePanel>
        ) : null}

        {loadStatus === 'unsupported' ? (
          <ModulePanel title="Подарунки">
            <p className={styles.stateText}>{loadError}</p>
          </ModulePanel>
        ) : null}

        {hasDraft && isEditable ? (
          <Switch>
            <Route exact path="/marketing/gifts" render={() => <Redirect to="/marketing/gifts/fund" />} />
            <Route exact path="/marketing/gifts/fund" component={GiftsFund} />
            <Route exact path="/marketing/gifts/rules" component={GiftsRules} />
            <Route exact path="/marketing/gifts/packaging" component={GiftsPackaging} />
            <Route render={() => <Redirect to="/marketing/gifts/fund" />} />
          </Switch>
        ) : null}
      </div>
    </div>
  )
}

function MarketingGifts() {
  return (
    <GiftsConfigProvider>
      <GiftsFundProvider>
        <MarketingGiftsBody />
      </GiftsFundProvider>
    </GiftsConfigProvider>
  )
}

export default MarketingGifts
